import React, {useState, useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SearchLookupMaintenance from './SearchLookupMaintenance';
import AddLookupMaintenance from './AddLookupMaintenance/AddLookupMaintenance';
import {TRANSLATION_TABLE} from '../../constants/ReusableRoleAccess';
import {useSelector} from 'react-redux';
import useUnsavedChangesWarning from '../../util/CustomHooks';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function LookupMaintenanceTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [rowData, setRowData] = useState('');

  const {roleData} = useSelector(({role}) => role);
  const TranslationTableAccess = roleData?.window?.[TRANSLATION_TABLE]?.['TT'];

  const showAlertRef = useRef(false);
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchLookupMaintenance
            setValue={setValue}
            setRowData={setRowData}
            TranslationTableAccess={TranslationTableAccess}
          />
        ) : null}
      </div>
      <div className={classes.subContent}>
        {value === 1 ? (
          <AddLookupMaintenance
            setValue={setValue}
            rowData={rowData}
            {...alertProps}
            TranslationTableAccess={TranslationTableAccess}
          />
        ) : null}
      </div>
    </div>
  );
}
